import { render, staticRenderFns } from "./extend_form.vue?vue&type=template&id=630781bc&scoped=true"
import script from "./extend_form.vue?vue&type=script&lang=js"
export * from "./extend_form.vue?vue&type=script&lang=js"
import style0 from "./extend_form.vue?vue&type=style&index=0&id=630781bc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630781bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630781bc')) {
      api.createRecord('630781bc', component.options)
    } else {
      api.reload('630781bc', component.options)
    }
    module.hot.accept("./extend_form.vue?vue&type=template&id=630781bc&scoped=true", function () {
      api.rerender('630781bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_detail/components/extend_form.vue"
export default component.exports